import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileMainComponent } from './user-profile-main/user-profile-main.component';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserProfileEditComponent } from './user-profile-edit/user-profile-edit.component';
import {SharedModule} from "../../shared/shared.module";



@NgModule({
  declarations: [UserProfileMainComponent, UserProfileEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule
  ],
    exports: [UserProfileMainComponent],
})
export class UserprofileModule { }
